import { get } from 'framework/api/http';
import { useQuery } from 'react-query';

/* Get user dashboard video list */
export const getDashboardTop10Videos = async () => {
  const res = await get(`/enterprise-media-api/get_top10_videos`);
  return res?.data || [];
};

/* Use Query as a Hook */
export const useGetDashboardTop10Videos = (onSuccess: any, onError: any) => {
  return useQuery('dashboard-top-videos', getDashboardTop10Videos, {
    refetchOnWindowFocus: false,
    enabled: false,
    retry: 0,
    onSuccess,
    onError,
  });
};

export default useGetDashboardTop10Videos;
